import { QueryClient } from '@tanstack/react-query';

import { queries } from 'app/constants/queries';

export const clearRelationshipIndexData = ({
  queryClient,
}: {
  queryClient: QueryClient;
}) => {
  void queryClient.invalidateQueries([queries.payeeUnclaimedPayeeRelationships]);
  void queryClient.invalidateQueries([queries.payeePayeeRelationships]);
  void queryClient.invalidateQueries([queries.payeeQuickPayableInvoices]);
  void queryClient.invalidateQueries([queries.payeeRelationshipsContactInfo]);
};

export const clearRelationshipShowData = async ({
  queryClient,
  relationshipIdsBeingClaimed,
}: {
  queryClient: QueryClient;
  relationshipIdsBeingClaimed: string[];
}) => {
  for (const relationshipId of relationshipIdsBeingClaimed) {
    await queryClient.invalidateQueries([queries.payeePayeeRelationshipsShow, relationshipId]);
  }
};
